import { Button, createTheme, styled } from '@mui/material';

import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

export async function checkABN(abn) {
  const response = await fetch(`https://abr.business.gov.au/json/AbnDetails.aspx?callback=abnCallback&abn=${abn}&guid=4323553b-7eca-4ef2-974d-97c38996e1a9`);

  const data = await response.text();

  let jsonData = eval(data);

  if (jsonData.Message.length !== 0) {
    return false;
  }

  return jsonData.EntityName;
}

export function formatDatetime(isoString) {
  // Convert the ISO string to a Date object
  const date = new Date(isoString);

  // Define an array of month names
  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  // Extract the components
  const day = date.getDate();
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, '0'); // Ensure two digits
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');

  // Format the date and time as "21 Mar 2024, 05:06:03"
  const humanReadableDateTime = `${day} ${month} ${year}, ${hours}:${minutes}:${seconds}`;

  return humanReadableDateTime;
}

export const TextButton = styled(Button)(({ theme }) => ({
  color: 'rgb(0, 15, 30, 0.6)',
  textTransform: 'none',
  padding: '0.5vw 0.75vw',
  borderRadius: '1vw', backgroundColor: 'rgb(254, 254, 255, 0.5)',
}));

export const darkTheme = createTheme({
  palette: {
    mode: 'light',
  },
});

export const PaginationNavigation = ({ onNextPage, onPrevPage }) => (

  <div style={{ display: 'flex', alignItems: 'center' }}>

    <TextButton variant="text" style={{ color: 'rgb(0, 15, 30, 0.6)', fontSize: '0.9vw', cursor: 'pointer', padding: '0.8vw', minWidth: 0, borderRadius: '1vw', backgroundColor: 'rgb(254, 254, 255, 0.5)', marginLeft: '1vw' }} onClick={onPrevPage}>
      <ArrowBackIosNewIcon style={{ fontSize: '1vw' }} />
    </TextButton>

    <TextButton variant="text" style={{ color: 'rgb(0, 15, 30, 0.6)', fontSize: '0.9vw', cursor: 'pointer', padding: '0.8vw', minWidth: 0, borderRadius: '1vw', backgroundColor: 'rgb(254, 254, 255, 0.5)', marginLeft: '0.8vw' }} onClick={onNextPage}>
      <ArrowForwardIosIcon style={{ fontSize: '1vw' }} />
    </TextButton>

  </div>

);
